import React from "react";
import PreperationSectionTest from "./PreperationSectionTest";
import PreperationSectionBooks from "./PreperationSectionBooks";

// bg-[#F8FCFD]
const PreperationSection = ({tests, books}) => {

  if(!tests || !books) return;
  if(tests.length === 0 || books.length === 0) return;
    
  return (
    <div className="flex grid grid-cols-1 lg:grid-cols-2 md:grid-cols-2 gap-[1rem] lg:gap-[2rem] mx-[0rem] my-[1rem] md:p-10 p-4">
      <div className="bg-[#F8FCFD] ">
        <PreperationSectionTest tests = {tests}/>
      </div>
      <div className="bg-[#F8FCFD] ">
        <PreperationSectionBooks books = {books}/>
      </div>
    </div>
  );
};

export default PreperationSection;
